import moment from 'moment'

export default (time) => {
  if (!moment.isMoment(time)) time = moment(time)

  return time.format('h:mm A')
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/formatters/short_time_of_day.js
 **/